import { style } from 'styled-system';

export const columnWidth = style({
  prop: 'columns',
  cssProperty: 'width',
  transformValue: (columns) => 100 / Number(columns) + '%',
});

export const gutterParent = style({
  prop: 'gutter',
  cssProperty: 'margin',
  key: 'space',
  transformValue: (g) => `${-g / 2}px`,
});

export const gutter = style({
  prop: 'gutter',
  key: 'space',
  cssProperty: 'padding',
  transformValue: (g) => `${Number(g) / 2}px`,
});

export const getTileOrder = (index: number) => (index + 1) * 2;

export const getRowComponentOrder = (shownAfterPosition: number, columns: number | string) => {
  columns = Number(columns);
  const afterRow = Math.ceil(shownAfterPosition / columns);
  return afterRow * columns * 2 + 1;
};

const rowStyleCache: { [key: string]: typeof style } = {};
export const rowComponentOrder = (shownAfterPosition: number) => {
  if (rowStyleCache[`${shownAfterPosition}`]) {
    return rowStyleCache[`${shownAfterPosition}`];
  }
  const stl = style({
    prop: 'columns',
    cssProperty: 'order',
    transformValue: (columns) => getRowComponentOrder(shownAfterPosition, columns),
  });
  (rowStyleCache as any)[`${shownAfterPosition}`] = stl;
  return stl;
};
